import {
  ExportData,
  exportData,
  getContactsAuto,
  GetSource,
  getSource,
  PostCollect,
  postCollect,
  PostContactsAuto,
  postContactsAuto,
} from '@/api/phishing-mail-collect'
import { Message } from '@/components/message'
import { useRequest } from 'ahooks'
import { message } from 'antd'
import { useEffect } from 'react'

interface UsePostCollectProps {
  postCollectListParams: PostCollect
}
export const usePostCollectList = (props: UsePostCollectProps) => {
  const { postCollectListParams } = props
  const {
    data,
    loading,
    refreshAsync: run,
  } = useRequest(
    () =>
      postCollect({ ...postCollectListParams, email_keyword: postCollectListParams.name_keyword }),
    {
      refreshDeps: [postCollectListParams],
      onError(err: any) {
        Message.error(err?.msg || '列表获取失败')
      },
    },
  )

  return [data?.data, loading, run] as const
}
// 查询上次更新时间
export const useContactsAuto = () => {
  const {
    data,
    runAsync: run,
    cancel,
  } = useRequest((datas: PostContactsAuto) => getContactsAuto(datas), {
    manual: true,
    pollingInterval: 3000,
    onError(err: any) {
      Message.error(err?.msg || '查询上次更新时间失败')
    },
  })

  useEffect(() => {
    if (data?.data?.flag === 2) {
      cancel()
    }
  }, [data?.data])

  return [run, data?.data?.collect_time, data?.data?.flag, cancel] as const
}
// 邮箱收集
export const usePostContactsAuto = () => {
  const { runAsync: run, loading } = useRequest(
    (data: PostContactsAuto) => postContactsAuto(data),
    {
      manual: true,
      // loadingDelay: 300,
      onError(err: any) {
        Message.error(err?.msg || '邮箱收集失败')
      },
    },
  )
  return [run, loading] as const
}

// 获取邮箱的收集来源
export const useGetSource = () => {
  const {
    runAsync: run,
    data,
    loading,
  } = useRequest((datas: GetSource) => getSource(datas), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取邮箱的收集来源失败')
    },
  })
  return [run, data?.data?.items, loading] as const
}

// 导出数据
export const useExportData = () => {
  const { runAsync: run } = useRequest((data: ExportData) => exportData(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '导出数据失败')
    },
  })
  return [run] as const
}
